import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GibberishDetectorService {

  constructor() { }

  isGibberish(input: string): boolean {
    // Basic gibberish detection logic
    // This can be as complex as you need it to be
   
    const words = input.split(/\s+/);
    
    const nonWords = words.filter(word => word.match(/^[a-zA-Z]+$/));
   
    return nonWords.length > words.length / 2;
  }
}